export const ROOT_URL = 'http://descubra-seu-futuro.rpc.com.br/'



// WEBPACK FOOTER //
// ./src/constants/production/application.js